export const DRAWER_WIDTH = 400
export const DRAWER_WIDTH_MOBILE = 300
